import React, { useEffect, useCallback } from 'react';
import { useFormikContext } from 'formik';
import _debounce from 'lodash/debounce';

const AutoSave = ({ debounceMs }: { debounceMs: any }): null => {
  const { values, submitForm, dirty } = useFormikContext();

  const debouncedSubmit = useCallback(
    _debounce(() => {
      return submitForm();
    }, debounceMs),
    [submitForm, debounceMs],
  );

  useEffect(() => {
    if (!dirty) {
      return undefined;
    }

    debouncedSubmit();

    return () => {
      debouncedSubmit.cancel();
    };
  }, [debouncedSubmit, dirty, values]);

  return null;
};

export default React.memo(AutoSave) as any;
